export interface ISessionMeetingActivityActions {
  readonly delete: boolean
  readonly edit: boolean
  readonly show: boolean
}
